import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  TextField,
  MenuItem,
  Button,
  Autocomplete,
} from "@mui/material";
import React, { useState, useContext, useEffect } from "react";
import PsContext from "../../context";
import {
  _ADD_TASK,
  _LIST_STAFFS,
  _LIST_TASK_CATEGORIES,
  _LIST_TASK_PRIORITIES,
} from "../../models/task";
import { Dialog, List, SwipeAction, Toast } from "antd-mobile";

const AddTask = (props) => {
  const context = useContext(PsContext);

  // Sample state for managing selections
  const [selStaff, setSelStaff] = useState(null);
  const [selPriority, setSelPriority] = useState("");
  const [selCategory, setSelCategory] = useState("");
  const [taskTitle, setTaskTitle] = useState("");
  const [taskDetails, setTaskDetails] = useState("");
  const [completionDate, setCompletionDate] = useState("");
  const [staffs, setStaffs] = useState([]);
  const [priorities, setPriorities] = useState([]);
  const [categories, setCategories] = useState([]);
  const [file, setFile] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    /*  if (props.categories && props.categories.length > 0)
      setCategories(props.categories);

    if (props.priorities && props.priorities.length > 0)
      setPriorities(props.priorities);

    if (props.staffs && props.staffs.length > 0) setStaffs(props.staffs); */
    _LIST_STAFFS().then((res) => res.data && setStaffs(res.data));
    _LIST_TASK_PRIORITIES().then((res) => res.data && setPriorities(res.data));
    _LIST_TASK_CATEGORIES().then((res) => res.data && setCategories(res.data));
  }, [props.staffs, props.priorities, props.categories]);

  const handleSubmit = () => {
    // Validate all fields
    if (
      !selStaff ||
      !selPriority ||
      !selCategory ||
      !taskTitle ||
      !taskDetails ||
      !completionDate
    ) {
      setErrorMessage("Please fill in all required fields.");
      return;
    }

    // Create a task object
    const taskData = {
      staff_uuid: selStaff,
      category_id: selCategory,
      task_title: taskTitle,
      task_description: taskDetails,
      upload_file: file,
      date_to_complete: completionDate,
      priority_id: selPriority,
    };
    _ADD_TASK(taskData)
      .then((res) => {
        Toast.show({
          icon: "success",
          content: res.message ? res.message : "Task successfully saved!",
        });
        if (props.onSuccess) props.onSuccess();
      })
      .catch((error) => {
        console.error("Error saving task:", error);
        Toast.show({
          icon: "fail",
          content: "Error saving task. Please try again.",
        });
        if (props.onSuccess) props.onSuccess();
      });
  };

  return (
    <Card>
      <CardContent>
        {errorMessage && <div style={{ color: "red" }}>{errorMessage}</div>}
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Autocomplete
              options={staffs}
              getOptionLabel={(option) => option.emp_name}
              value={staffs.find((staff) => staff.uuid === selStaff) || null} // Find the staff object by uuid
              onChange={(event, newValue) => {
                if (newValue) {
                  setSelStaff(newValue.uuid); // Set selStaff to the uuid
                } else {
                  setSelStaff(null); // Handle the case when no staff is selected
                }
              }}
              renderInput={(params) => (
                <TextField {...params} label="Staff" fullWidth required />
              )}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              select
              fullWidth
              label="Category"
              value={selCategory}
              onChange={(e) => setSelCategory(e.target.value)}
              required
            >
              {categories.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.category_name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Task Title"
              value={taskTitle}
              onChange={(e) => setTaskTitle(e.target.value)}
              required
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Task Details"
              value={taskDetails}
              onChange={(e) => setTaskDetails(e.target.value)}
              multiline
              rows={4}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <input
              type="file"
              accept=".pdf,.doc,.docx,.jpg,.png"
              onChange={(e) => setFile(e.target.files[0])}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              type="date"
              label="Completion Date"
              value={completionDate}
              onChange={(e) => setCompletionDate(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              select
              fullWidth
              label="Priority"
              value={selPriority}
              onChange={(e) => setSelPriority(e.target.value)}
              required
            >
              {priorities.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.priority_level}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>
        <Grid container spacing={2} mt={2} alignItems="flex-end">
          <Grid item xs={12} md={3}>
            <Button variant="contained" fullWidth onClick={handleSubmit}>
              Save
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default AddTask;
